export const digitalProductPassport = {
  digitalProductPassport: "Ψηφιακό Διαβατήριο Προϊόντος",
  batteryPassport: "Διαβατήριο Μπαταρίας",
};
